import validate from "/home/ploi/intercomm.cgworks.eu/node_modules/nuxt/dist/pages/runtime/validate.js";
import alwaysruns_45global from "/home/ploi/intercomm.cgworks.eu/middleware/alwaysruns.global.ts";
export const globalMiddleware = [
  validate,
  alwaysruns_45global
]
export const namedMiddleware = {
  auth: () => import("/home/ploi/intercomm.cgworks.eu/middleware/auth.ts")
}